import { InjectionToken } from '@angular/core';

export const AUTHENTICATION = new InjectionToken<AuthenticationServiceType>('AUTHENTICATION');

export interface AuthenticationServiceType {
    isAuthenticated(): boolean;
}
